<template>
    <div class="tw-flex tw-flex-wrap tw-w-full tw-px-5">
        <profile class="tw-w-full md:tw-w-4/12 tw-flex tw-pb-4 tw-pr-4" :pageOptions="pageOptions" :subscriber="subscriber" :options="options" :artist="artist" :spotifyArtist="spotifyArtist" :shareLinks="shareLinks"/>
        <section class="tw-w-full md:tw-w-8/12">
            <div id="resultsContainer" class="tw-mb-24">
                <div class="tw-w-full tw-py-5 tw-flex">
                    <inertia-link :href="tenant ? `/backstage` : `/artist/${artist.artista_url}/backstage`" class="tw-text-white tw-font-sans tw-text-sm">
                        <i class="fas fa-arrow-left tw-mr-1"></i>
                        Voltar
                    </inertia-link>
                </div>
                <section-post :pageOptions="pageOptions" :artist="artist" :spotifyArtist="spotifyArtist" :post="post" :single="true" class="tw-px-5 post tw-rounded"></section-post>
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/SingleLayout';
import Index from '@/Pages/backstage/layout';
import Profile from './components/profile';
import EventBus from '@/eventbus';
import SectionPost from './components/post';


export default {
    props: ['artist', 'options', 'post', 'spotifyArtist', 'shareLinks', 'subscriber', 'pageOptions'],
    components: {Profile, SectionPost},
    layout: (h, page) => {
      return h(Layout, [
        h(Index, [page]),
      ])
    },
    data(){
        return{
            photos: [],
            page: 1,
            infiniteId: +new Date(),
        }
    },
    metaInfo() {
        return {
            title: `${this.artist.nickname}`,
        }
    },
    methods: {
    },
    mounted(){
        const vm = this;
        setTimeout(() => {
            EventBus.$emit('artist', {'pageOptions': this.pageOptions, 'artist': this.artist, 'spotifyArtist': this.spotifyArtist});
        }, 10);
    },
}
</script>

<style>
.v-list{
    padding: 0!important;
}

.post{
    background: #272727!important;
}

#visibility{
    font-size: 0.7em!important;
    padding: 1px 7px!important;
    margin-top: 1px!important;
}

</style>
